import React from 'react';

import {
  Grid,
  Typography,
  TypographyListItem,
  TypographyList,
} from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import { PROMO_CODE, NAMES } from './constants';
import { validationSchema } from './schemas';

export const AddPromoCodeForm = withForm({
  validationSchema: validationSchema,
  enableReinitialize: true,
})(
  ({
    children,
    values,
    title,
    loading,
    onClose,
    onLoadPromoCodes,
    onExited,
    open,
  }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
      >
        <SidePageV2.Title
          title={'Add Promo Code'}
          subTitle={`${title} (${values[NAMES].length})`}
        />
        <SidePageV2.Content loading={loading}>
          <Grid container direction={'column'} spacing={3}>
            <Grid item>
              <FormField.Select
                label={'Promo code'}
                required={true}
                name={PROMO_CODE}
                source={onLoadPromoCodes}
                padding={0}
              />
            </Grid>
            <Grid item>
              <Typography intensity={200}>Selected:</Typography>
              <TypographyList>
                {values[NAMES].map((name) => (
                  <TypographyListItem>{name}</TypographyListItem>
                ))}
              </TypographyList>
            </Grid>
          </Grid>
        </SidePageV2.Content>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);
